import { useState, useEffect } from 'react';
import moment from 'moment';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip } from '@mui/material';
import { NoRecordFound, PageLoader } from '../../../shared_elements';
import { ShowAttachments } from '../../../shared_elements/components';
import { globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { trackActivity } from '../../../utils/mixpanel';
import { getApprovalTimelineApi } from '../apiService';
import AttachFileIcon from '@mui/icons-material/AttachFile';

// Approval history modal for the Titan Multi Approval Flow 
const MultiApprovalTimeline = ({ invoiceSlug, approvalSlugs = [], toggleModalFn }) => {
    const [isLoading, setLoading] = useState(false);
    const [timeLine, setTimeLine] = useState([]);
    const [attachmentsModal, setAttachmentsModal] = useState({ modal: false, data: null });

    const getTimeLineHistory = async () => {
        if (!approvalSlugs.length) return
        setLoading(true)
        try {
            const response = await globalGetService(getApprovalTimelineApi(invoiceSlug, approvalSlugs[0]))
            const combined = checkApiStatus(response) ? (response?.data?.data || []) : []
            setTimeLine(combined)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getTimeLineHistory()
    }, [])

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Multi Approval Flow Timeline`, page_type })
    }

    return (
        <>
            {isLoading ? <PageLoader /> :
                <Dialog
                    open
                    aria-labelledby="scroll-dialog-title"
                    className='add-lease-dialog'
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header' id="scroll-dialog-title">Approval Flow Timeline</DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <TableContainer style={{ maxHeight: !isLoading && timeLine?.length === 0 ? "auto" : `${window.innerHeight - 480}px`, overflow: "auto" }} component={Paper} className="scrollable-table scrollable-table-container">
                            <Table size="small" className="mui-table-format" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="nowrap-cell range-header"><b>Approval Stage</b></TableCell>
                                        <TableCell className="nowrap-cell range-header" sx={{ whiteSpace: 'nowrap' }}><b>Approved / Rejected By</b></TableCell>
                                        {/* <TableCell className="nowrap-cell range-header"><b>Status From</b></TableCell> */}
                                        <TableCell className="nowrap-cell range-header"><b>Status</b></TableCell>
                                        <TableCell className="nowrap-cell range-header"><b>Date &amp; Time</b></TableCell>
                                        <TableCell className="nowrap-cell range-header"><b>Reason</b></TableCell>
                                        <TableCell className="nowrap-cell range-header"><b>Attachments</b></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {timeLine?.length > 0 && timeLine.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell sx={{ minWidth: "120px" }}>{row?.titan_control_stage_name || '--'}</TableCell>
                                            <TableCell sx={{ minWidth: "100px" }}>{row?.member_info?.name || row?.changed_by?.name || '--'}</TableCell>
                                            {/* <TableCell sx={{ minWidth: "100px" }}>{row?.status_from?.label || '--'}</TableCell> */}
                                            <TableCell sx={{ minWidth: "60px" }}>{row?.status_to?.label || '--'}</TableCell>
                                            <TableCell sx={{ minWidth: "120px", whiteSpace: 'nowrap' }}>
                                                {row?.created_at && moment(row.created_at).isValid() ? moment(row.created_at).format('MMM DD, YYYY, hh:mm A') : "--"}
                                            </TableCell>
                                            <TableCell sx={{ minWidth: "180px" }}>{row?.remark || row?.comment || '--'}</TableCell>
                                            <TableCell sx={{ minWidth: "100px" }}>
                                                {row?.attachments?.length > 0 ? (
                                                    <Tooltip title="View Attachments" arrow>
                                                        <Box
                                                            sx={{ display: 'flex', alignItems: 'center', gap: '2px', cursor: 'pointer' }}
                                                            onClick={() => {
                                                                handleItemClicked('AttachmentsIcon')
                                                                setAttachmentsModal({ modal: true, data: { attachments: row.attachments } })
                                                            }}
                                                        >
                                                            <AttachFileIcon fontSize="small" color="primary" />
                                                            <Box className="attachment-count">({row.attachments.length})</Box>
                                                        </Box>
                                                    </Tooltip>
                                                ) : '--'}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {!isLoading && timeLine?.length === 0 && <NoRecordFound />}
                    </DialogContent>
                    <DialogActions>
                        <Box style={{ float: 'right' }}>
                            <Button className='cancel-btn' onClick={() => { toggleModalFn(); handleItemClicked('Close Button') }} color="primary" variant='outlined' sx={{ marginRight: "5px" }} size="small">Close</Button>
                        </Box>
                    </DialogActions>
                </Dialog>}
            {attachmentsModal.modal && (
                <ShowAttachments
                    moduleName="Approval Timeline"
                    attachmentsData={attachmentsModal}
                    toggleModalFn={() => setAttachmentsModal({ modal: false, data: null })}
                    permissionKey='invoices'
                    onViewDisabled={true}
                />
            )}
        </>
    )
}
export default MultiApprovalTimeline
